// extracted by mini-css-extract-plugin
export default {"text":"ReferralProgramPromoModal__text--18sjk"};